

import { _colorStringFilter } from "gsap/gsap-core";
import AssetsManager from "js/components/AssetsManager";
import GameManager from "js/components/GameManager";
import LocaleManager from "js/components/LocaleManager";
import { Container, NineSlicePlane, TextStyle, Text, Sprite, DEG_TO_RAD, Graphics, Texture, BaseTexture } from "pixi.js";
import tools from "tools";
import Btn2 from "./btn2";

const WIDTH = 750;
const HEIGHT = 120;

export default class ChallengerBtn extends Container {

    constructor(id, rank, name, img, color, score, invite) {

        super();

        tools.autobind(this);

        this._id = id;
        this._rank = rank;
        this._name = name;
        this._img = img;
        this._color = color;
        this._score = score;
        this._invite = invite;

        this._init();

    }



    _init() {

        let btnTexture = this._name == "You" ? AssetsManager.texturesPixi.yellowBg : AssetsManager.texturesPixi.basicWhiteBg;
        let _cof = .6;
        let _scale = .7 * _cof;
        this.bg = new NineSlicePlane(btnTexture, 30, 30, 30, 30);
        this.bg.tint = tools.hashtagToHexa(this._color);
        this.bg.scale.set(_scale);
        this.bg.width = WIDTH / _cof;
        this.bg.height = HEIGHT / _cof;
        this.bg.x = -this.bg.width / 2 * _scale;
        this.addChild(this.bg);


        const textStyle = new TextStyle({
            fontFamily: 'voodoo_casual-bold',
            fontSize: 30,
            letterSpacing: 2,
            align: "left",
            fill: 0xffffff
        });


        this.text = new Text(this._rank, textStyle);
        this.text.anchor.x = .5;
        this.text.anchor.y = .5;
        this.text.x = -WIDTH * .27;
        this.text.y = 40;
        this.addChild(this.text);

        let pic = Sprite.from(this._img);
        pic.height = HEIGHT * .45;
        pic.width = HEIGHT * .45;
        pic.anchor.y = .5;
        pic.y = 39;
        pic.x = -WIDTH * .19;


        let picBg = new Graphics();
        // picBg.lineStyle(1, 0x222222);
        picBg.beginFill(0x80f8ff);
        picBg.drawRoundedRect(0, -(pic.height + 10) * .5, pic.height + 10, pic.height + 10, 15);
        picBg.endFill();
        picBg.y = pic.y;
        picBg.x = pic.x - 5;
        this.addChild(picBg);


        let masque = new Graphics();
        masque.beginFill(0xff0000);
        masque.drawRoundedRect(0, -pic.height * .5, pic.height, pic.height, 15);
        masque.endFill();
        masque.y = pic.y;
        masque.x = pic.x;
        masque.isMask = true;
        this.addChild(pic);
        this.addChild(masque);


        pic.mask = masque;


        const nameStyle = new TextStyle({
            fontFamily: 'voodoo_casual-bold',
            fontSize: this._name == "You" ? 34 : 26,
            letterSpacing: 2,
            align: "left",
            fill: 0xffffff,
            stroke: this._name == "You" ? true : false,
            strokeThickness: 3
        });


        this.nameText = new Text(this._name, nameStyle);
        // this.nameText.anchor.x = .5;
        this.nameText.anchor.y = .5;
        this.nameText.x = pic.x + pic.width * .5 + 40;
        this.nameText.y = 40;
        this.addChild(this.nameText);


        const scoreStyle = new TextStyle({
            fontFamily: 'voodoo_casual-bold',
            fontSize: 28,
            letterSpacing: 2,
            align: "left",
            fill: 0xffffff
        });


        this.scoreText = new Text(this._score, scoreStyle);
        this.scoreText.anchor.x = 1;
        this.scoreText.anchor.y = .5;
        this.scoreText.x = WIDTH * .33;
        this.scoreText.y = 40;
        this.addChild(this.scoreText);


        this.inviteBtn = new Btn2(LocaleManager.words.playWith, 20, 0xffffff, 0x3C2FA1, AssetsManager.texturesPixi.friendsPicto, { width: 190, height: 80 }, .8);
        this.inviteBtn.click = this._inviteClick;
        this.inviteBtn.x = WIDTH * .22;
        this.inviteBtn.y = HEIGHT / 2 - 20;
        this.inviteBtn.visible = false;
        this.addChild(this.inviteBtn);


        this.enableInvite = this._invite;

    }

    _inviteClick() {
        console.log(this._id);

        /* playWithFriend */
        GameManager.H5SDK.getFriendsModule().playWithFriend(
            this._id,
            AssetsManager.base64Picture
        ).then(onPlay => {
            console.log("onPlay:", onPlay);
            if (onPlay) {
                console.log("play");
                this.emit("invite");
            } else {
                console.log("close");
            }
        });
    }



    set enableInvite(val) {

        this.inviteBtn.visible = val;
        this.scoreText.visible = !val

    }







}